import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
  initData?: string;
  isAuthenticated?: boolean;
}

export const ProtectedRoute = ({
  children,
  requireAuth = true,
  initData,
  isAuthenticated,
}: ProtectedRouteProps) => {
  if (requireAuth) {
    // Проверяем все возможные способы авторизации
    const telegramAuth = !!initData;
    const jwtAuth = !!isAuthenticated;
    const tokenAuth = !!localStorage.getItem("access_token");
    
    const hasAuth = telegramAuth || jwtAuth || tokenAuth;
    
    if (!hasAuth) {
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};

